/////// DUBLICATE IN MULTISTEPFORM-START4.JS ///////
/////// DUBLICATE IN MultiStepForm-UniqueCheck.JS ///////
const fileTypes = {
  rasterimg: ['image/png', 'image/jpeg', 'image/jpg'],
  image: ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml'],
  document: ['application/pdf'],
  both: [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/jpg',
    'application/pdf',
  ],
}

$(function () {
  $(document).ready(function () {
    var $sections = $('.multiStepForm--section')

    //// down sm ////
    if ($(window).width() < 768) {
      function navigateTo(index) {
        $sections.eq(index).removeClass('current')
      }

      function curIndex() {
        // Return the current index by looking at which section has the class 'current'
        return $sections.index($sections.filter('.current'))
      }

      // tab menu
      $('.multiStepForm--stepper-link').click(function (event) {
        event.preventDefault()

        $clickedTab = $(this)

        $currentGroup = $clickedTab.data('group')
        $currentElement = $clickedTab

        var $currentTab = $('.multiStepForm--stepper-link.current')
        var tab_group = $currentGroup

        $currentTab.removeClass('current')
        $currentElement.addClass('current')

        // Set Tab Panel of next tab to active
        $(".multiStepForm--section[data-group='" + tab_group + "']")
          .attr('data-state', 'active')
          .addClass('current')

        //Check if last section to show submit button
        var $currentTabIndex = tab_group.split('_')[1]
        var lastTab = $sections.length

        if (lastTab == $currentTabIndex) {
          $('.multiStepForm--navigation-next').hide()
          $('.multiStepForm--navigation-submit').show()
        } else {
          $('.multiStepForm--navigation-next').show()
          $('.multiStepForm--navigation-submit').hide()
        }

        $('html, body').stop(true, true).animate({
          scrollTop: 0,
        })
      })

      // tab menu
      $('.multiStepForm--close').click(function (event) {
        event.preventDefault()

        // Hide Tab panel
        $sections.attr('data-state', 'inactive').removeClass('current')
      })

      // summary edit link
      $('.multiStepForm--stepper-summary-link').click(function (event) {
        event.preventDefault()

        $clickedTab = $(this)

        var $currentTab = $('.multiStepForm--stepper-link.current')
        $currentGroup = $clickedTab.data('group')

        $currentTab.removeClass('current')
        $currentTab.attr('data-state', 'active')

        var tab_group = $currentGroup

        // Hide Tab panel
        $sections.attr('data-state', 'inactive')
        $sections.removeClass('current')

        // Set Tab Panel of next tab to active
        $(".multiStepForm--stepper-link[data-group='" + tab_group + "']")
          .attr('data-state', 'active')
          .addClass('current')
        $(".multiStepForm--section[data-group='" + tab_group + "']")
          .attr('data-state', 'active')
          .addClass('current')

        //Check if last section to show submit button
        var $currentTabIndex = tab_group.split('_')[1]
        var lastTab = $sections.length

        if (lastTab == $currentTabIndex) {
          $('.multiStepForm--navigation-next').hide()
          $('.multiStepForm--navigation-submit').show()
        } else {
          $('.multiStepForm--navigation-next').show()
          $('.multiStepForm--navigation-submit').hide()
        }

        navigateTo(curIndex())

        $('html, body').stop(true, true).animate({
          scrollTop: 0,
        })
      })

      // Next button goes forward if current block validates
      $('.multiStepForm--navigation-next').click(function (event) {
        event.preventDefault()

        var $currentTab = $('.multiStepForm--stepper-link.current')

        //Switch to next TabGroup
        $('.multiStepForm')
          .parsley()
          .whenValidate({
            group: 'block-' + curIndex(),
          })
          .done(function () {
            if ($currentTab.next().length > 0) {
              navigateTo(curIndex() + 1)

              // Set current Tab to valid
              $currentTab.attr('data-state', 'valid')

              // Hide Tab panel
              $sections.attr('data-state', 'inactive').removeClass('current')

              // Set next tab to current
              $currentTab.next().addClass('current')

              var tab_group = $currentTab.next().data('group')

              $currentTab.removeClass('current')

              // Set next Tab to active if not already valid
              // Only if not longer valid
              if (
                $('.multiStepForm')
                  .parsley()
                  .isValid({
                    group: 'block-' + tab_group,
                  }) &&
                $currentTab.data('group').match('^preview') === false
              ) {
                //Keep tab valid, preview is always valid
              } else {
                if ($currentTab.next().attr('data-state') === 'inactive') {
                  $currentTab.next().attr('data-state', 'active')
                }
              }

              $('html, body').stop(true, true).animate({
                scrollTop: 0,
              })
            }
          })
      })
    }

    //// up md ////
    if ($(window).width() > 767) {
      function navigateTo(index) {
        // Mark the current section with the class 'current'
        $sections
          .removeClass('current')
          .eq(index)
          .addClass('current')
          .attr('data-state', 'active')

        // Show only the navigation buttons that make sense for the current section:
        var atTheEnd = index >= $sections.length - 1
        $('.multiStepForm--navigation-next').toggle(!atTheEnd)
        $('.multiStepForm--navigation-submit').toggle(atTheEnd)
      }

      function curIndex() {
        // Return the current index by looking at which section has the class 'current'
        return $sections.index($sections.filter('.current'))
      }

      // tab menu
      $('.multiStepForm--stepper-link').click(function (event) {
        event.preventDefault()

        $clickedTab = $(this)

        //Check if click is forwad or backward
        var $currentTab = $('.multiStepForm--stepper-link.current')
        var $currentIndex = $currentTab.data('group').split('_')[1]
        var $clickIndex = $clickedTab.data('group').split('_')[1]
        var lastTab = $sections.length

        if (lastTab == $currentIndex) {
          // last tab don't validate
          $currentGroup = $clickedTab.data('group')
          $currentElement = $clickedTab

          $currentTab.removeClass('current')
          $currentTab.attr('data-state', 'valid')
          $currentElement.addClass('current').attr('data-state', 'active')

          var tab_group = $currentGroup

          // Hide Tab panel
          $sections.attr('data-state', 'inactive')
          $sections.removeClass('current')

          // Set Tab Panel of next tab to active
          $(".multiStepForm--section[data-group='" + tab_group + "']")
            .attr('data-state', 'active')
            .addClass('current')

          navigateTo(curIndex())

          $('html, body').stop(true, true).animate({
            scrollTop: 0,
          })
        } else if ($currentIndex > $clickIndex) {
          // click backwards
          $currentGroup = $clickedTab.data('group')
          $currentElement = $clickedTab

          $('.multiStepForm')
            .parsley()
            .whenValidate({
              group: 'block-' + curIndex(),
            })
            .done(function () {
              $currentTab.removeClass('current')
              $currentTab.attr('data-state', 'valid')
              $currentElement.addClass('current').attr('data-state', 'active')

              var tab_group = $currentGroup

              // Hide Tab panel
              $sections.attr('data-state', 'inactive')
              $sections.removeClass('current')

              // Set Tab Panel of next tab to active
              $(".multiStepForm--section[data-group='" + tab_group + "']")
                .attr('data-state', 'active')
                .addClass('current')

              navigateTo(curIndex())

              $('html, body').stop(true, true).animate({
                scrollTop: 0,
              })
            })
        } else if ($currentIndex < $clickIndex) {
          // Click forward
          $currentGroup = $clickedTab.data('group')
          $currentElement = $clickedTab

          $('.multiStepForm')
            .parsley()
            .whenValidate({
              group: 'block-' + curIndex(),
            })
            .done(function () {
              // Set current Tab to valid
              $currentTab.attr('data-state', 'valid')

              $currentTab.removeClass('current')
              $currentElement.addClass('current').attr('data-state', 'active')

              // Hide Tab panel
              $sections.attr('data-state', 'inactive')
              $sections.removeClass('current')

              var tab_group = $currentGroup

              // Validate and progress
              if (
                $('.multiStepForm')
                  .parsley()
                  .isValid({
                    group: 'block-' + tab_group,
                  }) &&
                $currentTab.data('group').match('^preview') === false
              ) {
                //Keep tab valid, preview is always valid
              }

              // Set Tab Panel of clicked tab to show
              $(".multiStepForm--section[data-group='" + tab_group + "']")
                .attr('data-state', 'active')
                .addClass('current')

              navigateTo(curIndex())

              $('html, body').stop(true, true).animate({
                scrollTop: 0,
              })
            })
        } //else: do nothing
      })

      // summary edit link
      $('.multiStepForm--stepper-summary-link').click(function (event) {
        event.preventDefault()

        $clickedTab = $(this)

        var $currentTab = $('.multiStepForm--stepper-link.current')
        $currentGroup = $clickedTab.data('group')

        $currentTab.removeClass('current')
        $currentTab.attr('data-state', 'valid')

        var tab_group = $currentGroup

        // Hide Tab panel
        $sections.attr('data-state', 'inactive')
        $sections.removeClass('current')

        // Set Tab Panel of next tab to active
        $(".multiStepForm--stepper-link[data-group='" + tab_group + "']")
          .attr('data-state', 'active')
          .addClass('current')
        $(".multiStepForm--section[data-group='" + tab_group + "']")
          .attr('data-state', 'active')
          .addClass('current')

        navigateTo(curIndex())

        $('html, body').stop(true, true).animate({
          scrollTop: 0,
        })
      })

      // Next button goes forward if current block validates
      $('.multiStepForm--navigation-next').click(function (event) {
        event.preventDefault()

        var $currentTab = $('.multiStepForm--stepper-link.current')

        //Switch to next TabGroup
        $('.multiStepForm')
          .parsley()
          .whenValidate({
            group: 'block-' + curIndex(),
          })
          .done(function () {
            if ($currentTab.next().length > 0) {
              navigateTo(curIndex() + 1)

              // Set current Tab to valid
              $currentTab.attr('data-state', 'valid')

              // Hide Tab panel
              $sections.attr('data-state', 'inactive')

              // Set next tab to current
              $currentTab.next().addClass('current')

              var tab_group = $currentTab.next().data('group')

              $currentTab.removeClass('current')

              // Set next Tab to active if not already valid
              // Only if not longer valid
              if (
                $('.multiStepForm')
                  .parsley()
                  .isValid({
                    group: 'block-' + tab_group,
                  }) &&
                $currentTab.data('group').match('^preview') === false
              ) {
                //Keep tab valid, preview is always valid
              } else {
                if (
                  $currentTab.next().data('state') === 'inactive' ||
                  'valid'
                ) {
                  $currentTab.next().attr('data-state', 'active')
                }
              }
              //Set Tab Panel of next tab to active
              $(".multiStepForm--section[data-group='" + tab_group + "']").attr(
                'data-state',
                'active',
              )

              $('html, body').stop(true, true).animate({
                scrollTop: 0,
              })
            }
          })
      })
    }

    // Prepare sections by setting the `data-parsley-group` attribute to 'block-0', 'block-1', etc.
    $sections.each(function (index, section) {
      $(section)
        .find(':input')
        .attr('data-parsley-group', 'block-' + index)
    })

    navigateTo(0) // Start at the beginning

    window.Parsley.addValidator('fileCount', {
      validateString: function (_value, min, max, parsleyInstance) {
        if (!window.FormData) {
          return true
        }
        var files = Array.from(parsleyInstance.$element[0].files)
        return files.length >= min && files.length <= max
      },
      requirementType: ['integer', 'integer'],
    })
    window.Parsley.addValidator('maxFileSize', {
      validateString: function (_value, maxSize, parsleyInstance) {
        if (!window.FormData) {
          return true
        }
        var files = Array.from(parsleyInstance.$element[0].files)
        return files.every(
          file => file.size <= (maxSize * 1024 * 1024).toFixed(0),
        )
      },
      requirementType: 'integer',
    })
    window.Parsley.addValidator('hasFileType', {
      validateString: function (_value, fileType, parsleyInstance) {
        if (!window.FormData) {
          return true
        }
        var files = Array.from(parsleyInstance.$element[0].files)
        return files.every(file => fileTypes[fileType].includes(file.type))
      },
      requirementType: 'string',
    })
  })
})
